export default __webpack_public_path__ + "c3a30ca6410d18a5d3ce2d0b782b3ebe.woff";